import React, { Component } from 'react';
import WithRouter from 'custom/withRouter';
import ProductCategoryList from './ProductCategoryList';
import ProductCategorySave from './ProductCategorySave';

class ProductCategoryPage extends Component {
    constructor(props, context) {
        super(props, context);
    }

    callListView = () => {
        this.props.navigate("/product/category");
    }

    callSaveView = () => {
        this.props.navigate("/product/category/add");
    }

    //This page renders either Product List or Product Save
    render() {
        const p = this.props;
        const productCategoryId = p.params.id;
        const isSave = productCategoryId || p.location.pathname === "/product/category/add";
        return (
            <div>
                {
                    isSave
                        ?
                        <ProductCategorySave
                            name="productCategorySave"
                            params={p.params}
                            isDialog={false}
                            onCancel={this.callListView}
                            title="Product Category Info" />
                        :
                        <ProductCategoryList onNew={this.callSaveView} title="List of Products Categories" />

                }
            </div>
        );
    }
}

export default WithRouter(ProductCategoryPage);